import React from 'react'
import styled from 'styled-components'
import { Page } from '../../common'
import { Claim } from './timeRelease/Claim'
import { Stake } from './staking/Stake'

export function Token() {
  return (
    <Page>
      <SideBySide>
        <Claim />
        <Stake />
      </SideBySide>
    </Page>
  )
}

const SideBySide = styled.div`
  margin: 30px auto 0 auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`
